var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from '@ember/object';
import Component from '@glimmer/component';
let TextField = (_class = class TextField extends Component {
  get autocomplete() {
    return this.args.autocomplete ?? 'off';
  }
  get hasError() {
    let {
      message,
      messageLevel
    } = this.args;
    return messageLevel === 'error' && message?.length > 0;
  }
  get step() {
    return this.args.step || 0.01;
  }
  handleInput(event) {
    let {
      value
    } = event.target;
    this.args.update(value);
  }
  focusOut({
    target
  }) {
    this.args.onFocusOut?.(target.value);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "handleInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusOut", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusOut"), _class.prototype)), _class);
export { TextField as default };